import { AlphaBadge, BetaBadge, NewBadge } from '@buffer-mono/popcorn'

import type { ChangelogEntryAudience } from './useChangelog'

import type { JSX } from 'react'

interface AudienceBadgeProps {
  audience?: ChangelogEntryAudience | null
  /**
   * Whether the "New" badge should render for a general-audience entry.
   * Defaults to true so isolated uses (announcement card, previews) keep their
   * "New" treatment. List/entry views pass `false` for every entry except the
   * most recent general one — see `useLatestNewEntryId`.
   */
  isNew?: boolean
  size?: 'small' | 'medium'
  className?: string
}

/**
 * Renders the appropriate badge for changelog entry audience.
 * Alpha/beta entries always show their respective badges. General-audience
 * entries show "New" only when `isNew` is true.
 */
export function AudienceBadge({
  audience,
  isNew = true,
  size = 'small',
  className,
}: AudienceBadgeProps): JSX.Element | null {
  if (audience === 'beta') {
    return <BetaBadge size={size} className={className} />
  }
  if (audience === 'alpha') {
    return <AlphaBadge size={size} className={className} />
  }
  if (!isNew) return null
  return <NewBadge className={className} />
}
